import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const slice = createSlice({
    name: "scanForm",
    initialState: {
        scanFormFilter: {
            keyword: "",
            start_day: "",
            end_day: "",
            //
            page: 1,
            page_size: 100,
            total: 0
        }
    },
    reducers: {
        updateScanFormListFilter(state, action) {
            state.scanFormFilter = {
                ...state.scanFormFilter,
                ...action.payload
            };
        },

        resetScanFormListFilter(state) {
            state.scanFormFilter = {
                ...state.scanFormFilter,
                //
                keyword: "",
                start_day: "",
                end_day: "",
                page: 1
            };
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    updateScanFormListFilter,
    resetScanFormListFilter
} = slice.actions;
